<template>
  <Command @click="trigger">
    <slot
      v-bind="{
        disabled: false,
        icon: 'settings',
        label: t('settings.title'),
        toolTip: t('settings.iconTooltip'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";

import {
  OverlayType,
  TransitionType,
  useUILayers,
} from "@/components/UILayers";
import Settings from "@/components/settings/Settings.vue";

import Command from "../command";

const { t } = useI18n();
const { capture: capturePosthogEvent } = usePostHog();

const { add } = useUILayers();

function trigger() {
  add(
    Settings,
    {},
    {
      overlay: OverlayType.Transparent,
      transition: TransitionType.SlideLeftMobileUp,
    }
  );
  capturePosthogEvent(posthogKeys.readingSettings);
}
</script>
